export const OGIMAGE = 'https://www.saatchiart.com/media/images/saatchi_art_og_image.jpg'
export const TITLE = 'Artwork: Buy Original Art Online, Paintings & More | Saatchi Art'
export const DESCRIPTION =
  'Saatchi Art is the best place to buy artwork online. Find the perfect original paintings, fine art photographs and more from the largest selection of original art in the world.'
